import { render, staticRenderFns } from "./event-max-capacity-modal.vue?vue&type=template&id=135b5254&scoped=true"
import script from "./event-max-capacity-modal.vue?vue&type=script&lang=js"
export * from "./event-max-capacity-modal.vue?vue&type=script&lang=js"
import style0 from "./event-max-capacity-modal.vue?vue&type=style&index=0&id=135b5254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b5254",
  null
  
)

export default component.exports